import React from "react";
import { Link } from "@material-ui/core";
import { Trans } from "react-i18next";
import styled from "styled-components";

import { TermsOfUseAndRefundPolicy } from "js/react/views/Billing/Checkout/components/TermsOfUseAndRefundPolicy";
import CheckoutController, { CheckoutControllerState } from "js/controllers/CheckoutController";
import { formatPrice } from "js/react/views/Billing/utils/prices";

const StyledLink = styled(Link)`
    &&& {
        text-decoration: underline;
        color: #11a9e2;
        cursor: pointer;
    }
`;

export const BillingIntervalText = CheckoutController.withState(function BillingIntervalText({
    includeTerms = false,
    termsComponent
}: { includeTerms?: boolean, termsComponent?: React.ReactElement } & CheckoutControllerState) {
    const isAnnual = CheckoutController.billingInterval === "year";

    const handleSwitchToMonthly = () => {
        CheckoutController.setBillingInterval("month");
    };

    const handleSwitchToAnnual = () => {
        CheckoutController.setBillingInterval("year");
    };

    const { annualSavingsPercentage, annualCostAtMonthlyRate, monthlyCost } = CheckoutController.amounts;

    const linkComponent = isAnnual
        ? <StyledLink onClick={handleSwitchToMonthly} />
        : <StyledLink onClick={handleSwitchToAnnual} />;

    const components: Record<string, React.ReactElement> = {
        billingIntervalLink: linkComponent
    };

    if (includeTerms) {
        components.terms = termsComponent ?? <TermsOfUseAndRefundPolicy textDecoration="none" />;
    }

    const currency = CheckoutController.currency;

    if (isAnnual) {
        return (
            <Trans
                i18nKey={includeTerms
                    ? "Pay {{monthly}}/mo ({{annual}}/yr) when you <billingIntervalLink>switch to monthly billing</billingIntervalLink>. By continuing you agree to our <terms />"
                    : "Pay {{monthly}}/mo ({{annual}}/yr) when you <billingIntervalLink>switch to monthly billing</billingIntervalLink>."
                }
                values={{ monthly: formatPrice(monthlyCost, currency), annual: formatPrice(annualCostAtMonthlyRate, currency) }}
                components={components}
            />
        );
    }

    return (
        <Trans
            i18nKey={includeTerms
                ? "Save {{savings}}% when you <billingIntervalLink>switch to annual billing</billingIntervalLink>. By continuing you agree to our <terms />"
                : "Save {{savings}}% when you <billingIntervalLink>switch to annual billing</billingIntervalLink>."
            }
            values={{ savings: annualSavingsPercentage.toFixed(0) }}
            components={components}
        />
    );
});
